/**
 * event.js
 * import axios for server calls
 */
import React from "react";
import 'reactjs-popup/dist/index.css';
import '../../style/eventstyle.css';


/**
 * displays event image for link to event details page
 */
function Event({event}) {

    return (   
    <span className="wrapper">
        <a href={`https://link2rsvp.netlify.app/eventid/${event._id}`}>
        <span className="wrapper">
            <img 
            src={event.articleImage} 
            alt={event.title}
            style={{width: "28%"}}
            className="image"
            />
        </span>
        <span className="tooltiptext">{event.title}</span>
            </a>
    </span>
    );
}

export default Event;